<template>
	<div class="themelist">
		<div style="display: flow-root; padding: 10px">
			<theme-list-top
				:theme-search="ThemeSearch"
				:loading-theme="LoadingTheme"
				:theme-table-data="ThemeTableData"
				:theme-page="ThemePage"
				:formatter-theme-template="formatterThemeTemplate"
				:handler-show-config-machine="handlerShowConfigMachine"
				@add-edit-theme="handleAddEditTheme"
				@search-theme="handleSearchTheme"
				@reset-theme="handleResetTheme"
				@add-machine="handleAddMachine"
				@theme-machine="handleThemeMachine"
				@delete-theme="handleDeleteTheme"
				@size-change="LoadCurrentSizeChange"
				@page-change="LoadCurrentThemeData"></theme-list-top>

			<!-- 添加/编辑主题 -->
			<el-dialog
				:modal-append-to-body="true"
				:append-to-body="true"
				v-loading="LoadingEditTheme"
				:visible.sync="ShowEditTheme"
				:title="ThemeType > 0 ? $t('edittheme.title2') : $t('edittheme.title1')"
				:fullscreen="true"
				:show-close="false"
				v-dialogDrag
				:close-on-click-modal="false"
				custom-class="AddEditTheme">
				<div
					:element-loading-text="$t('common.request')"
					style="padding-bottom: 80px">
					<div style="width: 100%; display: flow-root">
						<el-radio-group
							v-model="screen"
							style="margin-bottom: 5px"
							@input="handlerChangeDirection">
							<el-radio-button label="Portrait">{{
								$t("edittheme.shup")
							}}</el-radio-button>
							<el-radio-button label="Landscape">{{
								$t("edittheme.hengp")
							}}</el-radio-button>
						</el-radio-group>
					</div>
					<div style="display: flow-root; width: 100%">
						<div style="float: left; width: 1000px; display: flow-root">
							<el-form
								:model="ruleForm"
								ref="ruleForm"
								label-width="120px"
								label-position="top"
								class="list-ruleForm">
								<!-- 主题模板设置 -->
								<div style="width: 100%; display: flow-root; margin: 20px 0">
									<label style="color: #f56c6c; margin-right: 4px">*</label>
									<label>{{ $t("edittheme.template") }}</label>
								</div>
								<!-- 竖屏 -->
								<el-row
									v-if="screen == 'Portrait'"
									:gutter="20"
									style="padding-bottom: 10px; margin-bottom: 0">
									<el-col :span="24" style="padding-left: 14px">
										<div
											style="
												width: 100%;
												display: grid;
												grid-template-columns: repeat(auto-fill, 120px);
												gap: 20px;
											">
											<div
												style="margin-bottom: 15px; border-radius: 5px"
												v-for="(layouts, index) in zxlayoutset"
												:key="index">
												<img
													:key="index"
													@click="handlerSwitchLayout(layouts.value)"
													:class="
														layoutIndex == layouts.value ? 'athemes' : 'themes'
													"
													:src="
														'https://oss.reyeah.com/theme/shupin/' +
														index +
														'.png'
													"
													style="width: 100%; box-sizing: border-box" />
												<div style="text-align: center">
													{{ layouts.templateName || "unKnow" }}
												</div>
											</div>
										</div>
									</el-col>
								</el-row>
								<!-- 横屏 -->
								<el-row
									v-else-if="screen == 'Landscape'"
									:gutter="20"
									style="padding-bottom: 10px; margin-bottom: 0">
									<el-col :span="24" style="padding-left: 14px">
										<div
											style="
												width: 100%;
												display: grid;
												grid-template-columns: repeat(auto-fill, 120px);
												gap: 20px;
											">
											<div
												style="margin-bottom: 15px; border-radius: 5px"
												v-for="(layouts, index) in hxlayoutset"
												:key="index">
												<img
													:key="index"
													@click="handlerSwitchLayout(layouts.value)"
													:class="
														layoutIndex == layouts.value ? 'athemes' : 'themes'
													"
													:src="
														'https://oss.reyeah.com/theme/henpin/' +
														index +
														'.png'
													"
													style="width: 100%; box-sizing: border-box" />
												<div style="text-align: center">
													{{ layouts.templateName || "unKnow" }}
												</div>
											</div>
										</div>
									</el-col>
								</el-row>
								<!-- 基本信息配置 -->
								<el-row
									:gutter="20"
									style="padding-bottom: 15px; margin-bottom: 0">
									<el-col :span="6">
										<div
											style="width: 100%; display: flow-root; margin: 10px 0">
											<label style="color: #f56c6c; margin-right: 4px">*</label>
											<label>{{ $t("edittheme.name") }}</label>
										</div>
										<el-input
											v-model="ruleForm.name"
											:placeholder="$t('edittheme.names')"></el-input>
									</el-col>
									<el-col :span="6">
										<div
											style="width: 100%; display: flow-root; margin: 10px 0">
											<label style="color: #f56c6c; margin-right: 4px">*</label>
											<label>{{ $t("edittheme.color") }}</label>
										</div>
										<el-color-picker
											v-model="ruleForm.mainTone"></el-color-picker>
									</el-col>
								</el-row>
								<!-- 背景色设置 -->
								<div
									style="width: 100%; display: flow-root; margin-bottom: 10px">
									<label style="color: #f56c6c; margin-right: 4px">*</label>
									<label>{{ $t("edittheme.backgroundset") }}</label>
								</div>

								<el-row :gutter="20" style="padding-bottom: 10px">
									<el-col :span="24">
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.backColor.back"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.backse") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.backColor.popup"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.popup") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.backColor.label"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.label") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="
													ruleForm.backColor.productTag
												"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.productTag") }}</label
											>
										</el-form-item>
									</el-col>
								</el-row>

								<!-- 字体颜色设置 -->
								<div
									style="width: 100%; display: flow-root; margin-bottom: 10px">
									<label style="color: #f56c6c; margin-right: 4px">*</label>
									<label>{{ $t("edittheme.fontset") }}</label>
								</div>

								<el-row :gutter="20" style="padding-bottom: 10px">
									<el-col :span="24">
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.fontColor.price"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.price") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.fontColor.text"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.text") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.fontColor.content"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.content") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.fontColor.other"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.other") }}</label
											>
										</el-form-item>
										<el-form-item style="float: left; margin-right: 30px">
											<el-color-picker
												v-model="ruleForm.fontColor.btnText"></el-color-picker>
											<label
												style="
													display: inline-block;
													float: left;
													line-height: 40px;
													height: 40px;
													margin-right: 10px;
												"
												>{{ $t("edittheme.btnText") }}</label
											>
										</el-form-item>
									</el-col>
								</el-row>
								<!-- 商品展示 -->

								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">{{
											$t("edittheme.productlabel")
										}}</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.background") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'background')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'background',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'background',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.background"
																:src="ruleForm.goodsShow.background"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.backgroundTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["background"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["background"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.sellOutLabel") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'sellOutLabel')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'sellOutLabel',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'sellOutLabel',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.sellOutLabel"
																:src="ruleForm.goodsShow.sellOutLabel"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.sellOutLabelTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["sellOutLabel"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["sellOutLabel"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.productTop") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'productTop')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'productTop',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'productTop',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.productTop"
																:src="ruleForm.goodsShow.productTop"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.productTopTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["productTop"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["productTop"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.sellOutBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'sellOutBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'sellOutBtn',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'sellOutBtn',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:src="ruleForm.goodsShow.sellOutBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.sellOutBtnTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["sellOutBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["sellOutBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cartBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex"
													@mouseover="handleMouseEnterCard(0, 'cartBtn')"
													@mouseout="handleMouseLeaveCard">
													<div style="margin-right: 10px">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cartBtn',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cartBtn',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:src="ruleForm.goodsShow.cartBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.cartBtnTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cartBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cartBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.buyBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'buyBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'buyBtn',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'buyBtn',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:src="ruleForm.goodsShow.buyBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.buyBtnTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["buyBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["buyBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.productTray") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(0, 'productTray')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'productTray',
																		0
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'productTray',
																		0
																	)
															">
															<img
																v-if="ruleForm.goodsShow.productTray"
																:src="ruleForm.goodsShow.productTray"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.goodsShow.productTrayTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["productTray"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["productTray"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
								<!-- 商品展示页文字设置 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex; align-items: center">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">
											{{ $t("edittheme.productShowFontSet") }}
										</label>
										<el-switch
											v-model="ruleForm.goodsShow.isEnable"
											:active-value="1"
											:inactive-value="0">
										</el-switch>
									</div>
									<el-row
										v-if="ruleForm.goodsShow.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.productPriceSize')"
												prop="priceFontSize">
												<el-input
													v-model="ruleForm.goodsShow.priceFontSize"
													:placeholder="$t('edittheme.inputs')"
													><template slot="append">px</template></el-input
												>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.fontColor')"
												prop="priceFontColor">
												<el-color-picker
													v-model="
														ruleForm.goodsShow.priceFontColor
													"></el-color-picker>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row
										v-if="ruleForm.goodsShow.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.productNameSize')"
												prop="nameFontSize">
												<el-input
													v-model="ruleForm.goodsShow.nameFontSize"
													:placeholder="$t('productSpecify.inputs')"
													><template slot="append">px</template></el-input
												>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.fontColor')"
												prop="nameFontColor">
												<el-color-picker
													v-model="
														ruleForm.goodsShow.nameFontColor
													"></el-color-picker>
											</el-form-item>
										</el-col>
									</el-row>
								</el-card>
								<!-- 购物车 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">{{
											$t("edittheme.shopcartlabel")
										}}</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cartBackground") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'background')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'background',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'background',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.background"
																:src="ruleForm.cart.background"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.cart.backgroundTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cartBackground"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cartBackground"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cartIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'cartIcon')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cartIcon',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cartIcon',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.cartIcon"
																:src="ruleForm.cart.cartIcon"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.cart.cartIconTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cartIcon"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cartIcon"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.delBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'delBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'delBtn',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'delBtn',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.cart.delBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["delBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["delBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8" style="margin-top: 20px">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.add") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'add')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'add',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'add',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.add"
																:src="ruleForm.cart.add"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.cart.addTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["add"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["add"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.reduce") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'reduce')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'reduce',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'reduce',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.reduce"
																:src="ruleForm.cart.reduce"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.cart.reduceTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["reduce"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["reduce"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cartClear") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'cartClear')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cartClear',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cartClear',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.cartClear"
																:src="ruleForm.cart.cartClear"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.cart.cartClearTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cartClear"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cartClear"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.buyBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(1, 'buyBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'buyBtn',
																		1
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'buyBtn',
																		1
																	)
															">
															<img
																v-if="ruleForm.cart.buyBtn"
																:src="ruleForm.cart.buyBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.cart.buyBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["buyBtnC"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["buyBtnC"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
								<!-- 支付页 -->

								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">{{
											$t("edittheme.pay")
										}}</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.qrCodeBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'qrCodeBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'qrCodeBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'qrCodeBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.qrCodeBtn"
																:src="ruleForm.pay.qrCodeBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.pay.qrCodeBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["qrCodeBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["qrCodeBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cashBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'cashBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cashBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cashBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.cashBtn"
																:src="ruleForm.pay.cashBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.pay.cashBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cashBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cashBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.coinBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'coinBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'coinBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'coinBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.coinBtn"
																:src="ruleForm.pay.coinBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.pay.coinBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["coinBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["coinBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.creditCardBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="
															handleMouseEnterCard(2, 'creditCardBtn')
														"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'creditCardBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'creditCardBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.creditCardBtn"
																:src="ruleForm.pay.creditCardBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.pay.creditCardBtnTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["creditCardBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["creditCardBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.couponBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'couponBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'couponBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'couponBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.couponBtn"
																:src="ruleForm.pay.couponBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.pay.couponBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["couponBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["couponBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.closeBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'closeBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'closeBtn',
																		2
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'closeBtn',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.closeBtn"
																:src="ruleForm.pay.closeBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.pay.closeBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["closeBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["closeBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.qrCodeImg") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'qrCodeImg')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'qrCodeImg',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.qrCodeImg"
																:src="ruleForm.pay.qrCodeImg"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["qrCodeImg"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["qrCodeImg"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cashImg") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'cashImg')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cashImg',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.cashImg"
																:src="ruleForm.pay.cashImg"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cashImg"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cashImg"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.coinImg") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(2, 'coinImg')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'coinImg',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.coinImg"
																:src="ruleForm.pay.coinImg"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["coinImg"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["coinImg"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.creditCardImg") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="
															handleMouseEnterCard(2, 'creditCardImg')
														"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'creditCardImg',
																		2
																	)
															">
															<img
																v-if="ruleForm.pay.creditCardImg"
																:src="ruleForm.pay.creditCardImg"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["creditCardImg"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["creditCardImg"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
								<!-- 支付页文字设置 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex; align-items: center">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">
											{{ $t("edittheme.payPageFontSet") }}
										</label>
										<el-switch
											v-model="ruleForm.pay.isEnable"
											:active-value="1"
											:inactive-value="0">
										</el-switch>
									</div>
									<el-row
										v-if="ruleForm.pay.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.payFontSize')"
												prop="nameFontSize">
												<el-input
													v-model="ruleForm.pay.fontSize"
													:placeholder="$t('productSpecify.inputs')"
													><template slot="append">px</template></el-input
												>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.fontColor')"
												prop="fontColor">
												<el-color-picker
													v-model="ruleForm.pay.fontColor"></el-color-picker>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row
										v-if="ruleForm.pay.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.bjFontSize')"
												prop="priceFontSize">
												<el-input
													v-model="ruleForm.pay.priceFontSize"
													:placeholder="$t('productSpecify.inputs')"
													><template slot="append">px</template></el-input
												>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.fontColor')"
												prop="priceFontColor">
												<el-color-picker
													v-model="
														ruleForm.pay.priceFontColor
													"></el-color-picker>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row
										v-if="ruleForm.pay.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.qrCodeText')"
												prop="qrCodeText">
												<el-input
													v-model="ruleForm.pay.qrCodeText"
													:placeholder="$t('productSpecify.inputs')"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.creditCardText')"
												prop="creditCardText">
												<el-input
													v-model="ruleForm.pay.creditCardText"
													:placeholder="$t('productSpecify.inputs')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row
										v-if="ruleForm.pay.isEnable == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.cashText')"
												prop="cashText">
												<el-input
													v-model="ruleForm.pay.cashText"
													:placeholder="$t('productSpecify.inputs')"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="8">
											<el-form-item
												:label="$t('edittheme.coinText')"
												prop="coinText">
												<el-input
													v-model="ruleForm.pay.coinText"
													:placeholder="$t('productSpecify.inputs')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</el-card>
								<!-- 购买进度页 -->

								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">{{
											$t("edittheme.buy")
										}}</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.successIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'successIcon')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'successIcon',
																		3
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'successIcon',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.successIcon"
																:src="ruleForm.buy.successIcon"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.buy.successIconTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["successIcon"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["successIcon"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.failIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'failIcon')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'failIcon',
																		3
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'failIcon',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.failIcon"
																:src="ruleForm.buy.failIcon"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.buy.failIconTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["failIcon"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["failIcon"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.buyAgain") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'buyAgain')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'buyAgain',
																		3
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'buyAgain',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.buyAgain"
																:src="ruleForm.buy.buyAgain"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.buy.buyAgainTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["buyAgain"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["buyAgain"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.buyFail") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'buyFail')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'buyFail',
																		3
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'buyFail',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.buyFail"
																:src="ruleForm.buy.buyFail"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.buy.buyFailTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["buyFail"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["buyFail"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.stockUp") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'stockUp')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'stockUp',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.stockUp"
																:src="ruleForm.buy.stockUp"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["stockUp"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["stockUp"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.sell") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'sell')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
																beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'sell',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.sell"
																:src="ruleForm.buy.sell"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["sell"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["sell"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.load") }}
												</div>
												<div
													style="
														width: 100%;
														margin-bottom: 10px;
														display: flex;
													">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(3, 'load')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.gif'"
															:show-file-list="false"
															:before-upload="
															beforeUploadGif
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'load',
																		3
																	)
															">
															<img
																v-if="ruleForm.buy.load"
																:src="ruleForm.buy.load"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["load"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["load"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
								<!-- 年龄识别 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">
											{{ $t("edittheme.ageSb") }}
										</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<!-- 取消按钮 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cancelBtn") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'cancelBtn')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cancelBtn',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cancelBtn',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.cancelBtn"
																:src="ruleForm.age.cancelBtn"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.age.cancelBtnTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cancelBtn"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cancelBtn"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<!-- 识别成功图标 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.scanSuccessIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'successIcon')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'successIcon',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'successIcon',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.successIcon"
																:src="ruleForm.age.successIcon"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.age.successIconTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["successIcon"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["successIcon"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<!-- 识别失败图标 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.scanFailIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'failIcon')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'failIcon',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'failIcon',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.failIcon"
																:src="ruleForm.age.failIcon"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.age.failIconTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["failIcon"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["failIcon"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<!-- 二维码识别提示 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.qrCodeScanTips") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'qrCodeTip')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'qrCodeTip',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'qrCodeTip',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.qrCodeTip"
																:src="ruleForm.age.qrCodeTip"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.age.qrCodeTipTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["qrCodeTip"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["qrCodeTip"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<!-- 刷卡识别提示1 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cardTips1") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'cardTip1')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cardTip1',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cardTip1',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.cardTip1"
																:src="ruleForm.age.cardTip1"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.age.cardTip1Transparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cardTip1"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cardTip1"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<!-- 刷卡识别提示2 -->
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.cardTips2") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'cardTip2')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'cardTip2',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'cardTip2',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.cardTip2"
																:src="ruleForm.age.cardTip2"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.age.cardTip2Transparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.giftips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["cardTip2"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["cardTip2"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.processIconTips") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="
															handleMouseEnterCard(5, 'progressBarTip')
														"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'progressBarTip',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'progressBarTip',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.progressBarTip"
																:src="ruleForm.age.progressBarTip"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.age.progressBarTipTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["progressBarTip"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["progressBarTip"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.processIconGray") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="
															handleMouseEnterCard(5, 'progressBarGray')
														"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'progressBarGray',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'progressBarGray',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.progressBarGray"
																:src="ruleForm.age.progressBarGray"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.age.progressBarGrayTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["progressBarGray"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["progressBarGray"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.processIconSuccess") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="
															handleMouseEnterCard(5, 'progressBarSuccess')
														"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'progressBarSuccess',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'progressBarSuccess',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.progressBarSuccess"
																:src="ruleForm.age.progressBarSuccess"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.age.progressBarSuccessTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["progressBarSuccess"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["progressBarSuccess"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.toBuyIcon") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(5, 'goShopping')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'goShopping',
																		5
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'goShopping',
																		5
																	)
															">
															<img
																v-if="ruleForm.age.goShopping"
																:src="ruleForm.age.goShopping"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.age.goShoppingTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["goShopping"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["goShopping"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>

								<!-- 优惠券页 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">{{
											$t("edittheme.coupon")
										}}</label>
									</div>
									<el-row :gutter="20" style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.next") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(4, 'next')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'next',
																		4
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'next',
																		4
																	)
															">
															<img
																v-if="ruleForm.discount.next"
																:src="ruleForm.discount.next"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.discount.nextTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["next"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["next"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.back") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(4, 'back')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'back',
																		4
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'back',
																		4
																	)
															">
															<img
																v-if="ruleForm.discount.back"
																:src="ruleForm.discount.back"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="ruleForm.discount.backTransparent"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["back"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["back"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.discount") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div
														style="margin-right: 10px"
														@mouseover="handleMouseEnterCard(4, 'discount')"
														@mouseout="handleMouseLeaveCard">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'discount',
																		4
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'discount',
																		4
																	)
															">
															<img
																v-if="ruleForm.discount.discount"
																:src="ruleForm.discount.discount"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.discount.discountTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															zxlayoutset[layoutIndex]["discount"]
														}}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{
															hxlayoutset[layoutIndex]["discount"]
														}}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
								<!-- 通用页 -->
								<el-card
									shadow="never"
									style="padding: 10px; margin-bottom: 20px; cursor: pointer">
									<div style="width: 100%; display: flex; align-items: center">
										<label
											style="
												padding-right: 15px;
												line-height: 31px;
												font-size: 20px;
												margin-bottom: 15px;
											">
											{{ $t("edittheme.all") }}
										</label>
									</div>
									<div style="width: 100%; display: flex; align-items: center">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">
											{{ $t("edittheme.allBottomLabel") }}
										</label>
										<el-switch
											v-model="ruleForm.all.bottomLabel"
											active-value="1"
											inactive-value="0">
										</el-switch>
									</div>

									<div
										v-if="ruleForm.all.bottomLabel == '1'"
										style="
											width: 100%;
											display: flex;
											align-items: center;
											margin-top: 20px;
										">
										<label
											style="
												color: #f56c6c;
												margin-right: 4px;
												line-height: 31px;
											"
											>*</label
										>
										<label style="padding-right: 15px; line-height: 31px">
											{{ $t("edittheme.allHideFont") }}
										</label>
										<el-switch
											v-model="ruleForm.all.hideSystemText"
											:active-value="1"
											:inactive-value="0">
										</el-switch>
										<label
											style="
												padding-right: 15px;
												padding-left: 30px;
												line-height: 31px;
											">
											{{ $t("edittheme.allHideFontColor") }}
										</label>
										<el-color-picker
											v-model="ruleForm.all.hideSystemColor"></el-color-picker>
									</div>

									<el-row
										v-if="ruleForm.all.bottomLabel == '1'"
										:gutter="20"
										style="margin-top: 20px">
										<el-col :span="8">
											<el-card shadow="hover">
												<div style="width: 100%; margin-bottom: 10px">
													{{ $t("edittheme.allBottomLabelImg") }}
												</div>
												<div
													style="width: 100%; margin-bottom: 0; display: flex">
													<div style="margin-right: 10px">
														<el-upload
															class="image-uploader"
															:action="action"
															:headers="headers"
															:accept="'.jpg,.png'"
															:show-file-list="false"
															:before-upload="
																(response, file, fileList) =>
																	handleBeforeUpload(
																		response,
																		file,
																		fileList,
																		'bottomLabelImg',
																		6
																	)
															"
															:on-success="
																(response, file, fileList) =>
																	handleUploadSuccess(
																		response,
																		file,
																		fileList,
																		'bottomLabelImg',
																		6
																	)
															">
															<img
																v-if="ruleForm.all.bottomLabelImg"
																:src="ruleForm.all.bottomLabelImg"
																class="showimage" />
															<i
																v-else
																class="el-icon-plus image-uploader-icon"></i>
														</el-upload>
													</div>
													<div>
														<label style="margin-left: 10px">{{
															$t("edittheme.backgroundTransparent")
														}}</label>
														<el-slider
															:step="0.01"
															:min="0"
															:max="1"
															v-model.number="
																ruleForm.all.bottomLabelImgTransparent
															"
															show-input
															input-size="mini"
															style="margin-left: 10px"></el-slider>
													</div>
												</div>
												<div style="width: 100%">
													<el-link disabled class="font_12_yahei">{{
														$t("edittheme.gstips")
													}}</el-link>
													<el-link
														v-if="screen == 'Portrait'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ zxlayoutset[layoutIndex]["next"] }}px</el-link
													>
													<el-link
														v-else-if="screen == 'Landscape'"
														disabled
														class="font_12_yahei"
														>{{ $t("edittheme.jychicun")
														}}{{ hxlayoutset[layoutIndex]["next"] }}px</el-link
													>
												</div>
											</el-card>
										</el-col>
									</el-row>
								</el-card>
							</el-form>
						</div>
						<!-- +++实时预览+++ -->
						<div
							style="
								position: fixed;
								left: 1040px;
								top: 30px;
								width: 509px;
								display: flow-root;
							">
							<!-- 白色主题 -->
							<div class="phone">
								<div class="title">{{ $t('theme.list.767480-0') }}</div>
								<template v-if="CurrentCard == 0">
									<div style="width: 100%; overflow-y: scroll">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="CurrentCard == 1">
									<div
										style="width: 100%; overflow-y: scroll; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.cart.background
														? 'background: url(' +
														ruleForm.cart.background +
														'); background-size: 100% 100%; background-repeat: no-repeat; background-position: center; width: 70%; height: 100%; display: flex; justify-content: center;'
														: 'background: #e5e9f2; width: 70%; height: 100%; display: flex; justify-content: center;'
												">
												<div style="width: 100%">
													<div
														style="
															display: block;
															margin: 20px auto 40px auto;
															width: 22px;
															position: relative;
														">
														<img
															v-if="ruleForm.cart.cartIcon"
															:src="ruleForm.cart.cartIcon"
															:class="movefield == 'cartIcon' ? 'images' : ''"
															:style="
																'display: block; opacity: ' +
																ruleForm.cart.cartIconTransparent +
																'; width: 22px;'
															" />
														<div
															style="
																position: absolute;
																top: -5px;
																right: -20px;
																background-color: var(--vtm-surface);
																padding: 0 6px;
																border-radius: 100%;
																color: rgb(254, 160, 78);
																font-weight: bold;
																font-size: 14px;
															">
															5
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="movefield == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			movefield == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="movefield == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="movefield == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduceUnavailable"
																		:src="ruleForm.cart.reduceUnavailable"
																		:class="
																			movefield == 'reduceUnavailable'
																				? 'images'
																				: ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart
																				.reduceUnavailableTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="movefield == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="movefield == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduceUnavailable"
																		:src="ruleForm.cart.reduceUnavailable"
																		:class="
																			movefield == 'reduceUnavailable'
																				? 'images'
																				: ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart
																				.reduceUnavailableTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="movefield == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="movefield == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			movefield == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="movefield == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div style="width: 100%; margin-top: 16px">
														<div
															style="
																width: 75%;
																display: flex;
																margin: 0px auto;
																position: relative;
																background-color: #f2f2f2;
																height: 55px;
																border-radius: 5px;
																border: 2px solid #d2d2d2;
															">
															<img
																v-if="ruleForm.cart.delBtn"
																:src="ruleForm.cart.delBtn"
																:class="movefield == 'delBtn' ? 'images' : ''"
																:style="
																	'width: 20px; height: 20px; display: block; position: absolute; left: -10px; top: -9px; opacity: ' +
																	ruleForm.cart.delBtnTransparent +
																	';'
																" />
															<div
																style="
																	width: 35px;
																	height: 35px;
																	margin: 10px;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div
																style="
																	width: 52px;
																	height: 35px;
																	margin: 10px 10px 10px 0;
																	display: block;
																	background-color: rgb(211, 220, 230);
																	border-radius: 3px;
																"></div>
															<div style="display: flex">
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		border-radius: 5px 0 0 5px;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.reduce"
																		:src="ruleForm.cart.reduce"
																		:class="
																			movefield == 'reduce' ? 'images' : ''
																		"
																		:style="
																			'width: 16px; display: block; opacity: ' +
																			ruleForm.cart.reduceTransparent +
																			';'
																		" />
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		font-size: 20px;
																		color: #fea04e;
																		font-weight: bold;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-right: 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	2
																</div>
																<div
																	style="
																		width: 25px;
																		margin: 13.5px 0;
																		height: 25px;
																		border: 2px solid #d2d2d2;
																		border-radius: 0 5px 5px 0;
																		display: flex;
																		justify-content: center;
																		align-items: center;
																	">
																	<img
																		v-if="ruleForm.cart.add"
																		:src="ruleForm.cart.add"
																		:class="movefield == 'add' ? 'images' : ''"
																		:style="
																			'width: 16px; height: 16px; display: block; opacity: ' +
																			ruleForm.cart.addTransparent +
																			';'
																		" />
																</div>
															</div>
														</div>
													</div>
													<div
														style="
															width: 76%;
															padding: 12px 12%;
															margin-top: 10px;
															display: flex;
															align-items: center;
														">
														<div
															style="
																width: 65%;
																font-size: 20px;
																font-weight: bold;
															">
															Total Amount
														</div>
														<div
															style="font-size: 25px; color: rgb(254, 160, 78)">
															<span>38.88</span>
															<span
																style="
																	font-size: 12px;
																	font-weight: bold;
																	margin-left: 3px;
																"
																>{{ $t('theme.list.767480-1') }}</span
															>
														</div>
													</div>
													<div
														style="
															display: flex;
															align-items: center;
															justify-content: center;
															width: 70%;
															margin: 0 15%;
														">
														<img
															v-if="ruleForm.cart.cartClear"
															:class="movefield == 'cartClear' ? 'images' : ''"
															:src="ruleForm.cart.cartClear"
															:style="
																'display: block; width: 135px; margin-right: 10px; opacity: ' +
																ruleForm.cart.cartClearTransparent +
																';'
															" />
														<img
															v-if="ruleForm.cart.buyBtn"
															:class="movefield == 'buyBtn' ? 'images' : ''"
															:src="ruleForm.cart.buyBtn"
															:style="
																'display: block; width: 135px; opacity: ' +
																ruleForm.cart.buyBtnTransparent +
																';'
															" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="CurrentCard == 2">
									<div
										style="width: 100%; overflow-y: scroll; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: var(--vtm-surface);
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="movefield == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															'; height: 32px;'
														" />
													<div
														style="
															width: 78%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
													<img
														v-if="ruleForm.pay.couponBtn"
														:class="movefield == 'couponBtn' ? 'images' : ''"
														:src="ruleForm.pay.couponBtn"
														:style="
															'display: block; opacity: ' +
															ruleForm.pay.couponBtnTransparent +
															'; height: 32px;'
														" />
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 40%;
															margin-right: 3%;
															height: 120px;
															background-color: #d3dce6;
														"></div>
													<div
														style="
															width: 54%;
															margin-left: 3%;
															height: 120px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 110px;
															height: 110px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														height: 50px;
														margin-top: 6%;
														background-color: #d3dce6;
													"></div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div style="width: 50%">
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.qrCodeBtn"
																:class="
																	movefield == 'qrCodeBtn' ? 'images' : ''
																"
																:src="ruleForm.pay.qrCodeBtn"
																:style="
																	'width: 100%; height: 68px; display: block; opacity: ' +
																	ruleForm.pay.qrCodeBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.qrCodeImg"
																:class="
																	movefield == 'qrCodeImg' ? 'images' : ''
																"
																:src="ruleForm.pay.qrCodeImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.coinBtn"
																:class="movefield == 'coinBtn' ? 'images' : ''"
																:src="ruleForm.pay.coinBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.coinBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.coinImg"
																:class="movefield == 'coinImg' ? 'images' : ''"
																:src="ruleForm.pay.coinImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
													</div>
													<div style="width: 50%">
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.cashBtn"
																:class="movefield == 'cashBtn' ? 'images' : ''"
																:src="ruleForm.pay.cashBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.cashBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.cashImg"
																:class="movefield == 'cashImg' ? 'images' : ''"
																:src="ruleForm.pay.cashImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
														<div
															style="
																width: 100%;
																display: block;
																position: relative;
															">
															<img
																v-if="ruleForm.pay.creditCardBtn"
																:class="
																	movefield == 'creditCardBtn' ? 'images' : ''
																"
																:src="ruleForm.pay.creditCardBtn"
																:style="
																	'width: 100%; display: block; opacity: ' +
																	ruleForm.pay.creditCardBtnTransparent +
																	';'
																" />
															<img
																v-if="ruleForm.pay.creditCardImg"
																:class="
																	movefield == 'creditCardImg' ? 'images' : ''
																"
																:src="ruleForm.pay.creditCardImg"
																style="
																	width: 36.5px;
																	height: 36.5px;
																	display: block;
																	position: absolute;
																	top: 15px;
																	left: 48px;
																" />
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="CurrentCard == 3">
									<div
										style="width: 100%; overflow-y: scroll; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: var(--vtm-surface);
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="movefield == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															';'
														" />
													<div
														style="
															width: 78%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
													<img
														v-if="ruleForm.pay.couponBtn"
														:class="movefield == 'couponBtn' ? 'images' : ''"
														:src="ruleForm.pay.couponBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.couponBtnTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 80%;
															height: 80px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														height: 57px;
														margin-top: 8%;
														position: relative;
													">
													<div
														style="
															position: absolute;
															top: 0;
															left: 0;
															z-index: 2;
															width: 100%;
															height: 100%;
															display: flex;
															align-items: center;
															justify-content: center;
														">
														<div style="width: 30%; text-align: center">
															<img
																v-if="ruleForm.buy.successIcon"
																:class="
																	movefield == 'successIcon' ? 'images' : ''
																"
																:src="ruleForm.buy.successIcon"
																:style="
																	'width: 32px; height: 32px; display: block; margin: 0 auto; opacity: ' +
																	ruleForm.buy.successIconTransparent +
																	';'
																" />
															<div style="width: 100%; margin-top: 5px">
																Paying...
															</div>
														</div>
														<div style="width: 40%; text-align: center">
															<img
																v-if="ruleForm.buy.failIcon"
																:class="movefield == 'failIcon' ? 'images' : ''"
																:src="ruleForm.buy.failIcon"
																:style="
																	'width: 32px; height: 32px; display: block; margin: 0 auto; opacity: ' +
																	ruleForm.buy.failIconTransparent +
																	';'
																" />
															<div style="width: 100%; margin-top: 5px">
																Paid...
															</div>
														</div>
														<div style="width: 30%; text-align: center">
															<div
																style="
																	width: 26px;
																	height: 26px;
																	display: block;
																	border: 3px solid #d3dce6;
																	margin: 0 auto;
																	border-radius: 100%;
																"></div>
															<div style="width: 100%; margin-top: 5px">
																Delivered...
															</div>
														</div>
													</div>
													<div
														style="
															position: absolute;
															top: 15px;
															left: 86px;
															z-index: 1;
															width: 28%;
															height: 3px;
															background-color: #ff8924;
														"></div>
													<div
														style="
															position: absolute;
															top: 15px;
															left: 249px;
															z-index: 1;
															width: 28%;
															height: 3px;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.load"
														:class="movefield == 'load' ? 'images' : ''"
														:src="ruleForm.buy.load"
														style="width: 26px; height: 26px; display: block" />
													<div
														style="
															margin-left: 3%;
															height: 30px;
															line-height: 30px;
															font-size: 16px;
															text-align: center;
														">
														Delivering，please wait...
													</div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div
														style="
															width: 120px;
															margin-right: 5%;
															text-align: center;
														">
														<img
															v-if="ruleForm.buy.stockUp"
															:class="movefield == 'stockUp' ? 'images' : ''"
															:src="ruleForm.buy.stockUp"
															style="
																width: 60px;
																height: 60px;
																display: block;
																margin: 0 auto;
															" />
														<div style="margin-top: 5px">Successfully Paid</div>
													</div>
													<div
														style="
															width: 120px;
															margin-left: 5%;
															text-align: center;
														">
														<img
															v-if="ruleForm.buy.buyFail"
															:class="movefield == 'buyFail' ? 'images' : ''"
															:src="ruleForm.buy.buyFail"
															:style="
																'width: 60px; height: 60px; display: block; margin: 0 auto; opacity: ' +
																ruleForm.buy.buyFailTransparent +
																';'
															" />
														<div style="margin-top: 5px">Fail Paid</div>
													</div>
												</div>
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.sell"
														:class="movefield == 'sell' ? 'images' : ''"
														:src="ruleForm.buy.sell"
														style="height: 120px; display: block" />
												</div>
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.buy.buyAgain"
														:class="movefield == 'buyAgain' ? 'images' : ''"
														:src="ruleForm.buy.buyAgain"
														:style="
															'width: 208.5px; height: 67px; display: block; opacity: ' +
															ruleForm.buy.buyAgainTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="CurrentCard == 4">
									<div
										style="width: 100%; overflow-y: scroll; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: var(--vtm-surface);
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.pay.closeBtn"
														:class="movefield == 'closeBtn' ? 'images' : ''"
														:src="ruleForm.pay.closeBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.pay.closeBtnTransparent +
															';'
														" />
													<div
														style="
															width: 87%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
												</div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<div style="width: 100%; text-align: center">
														Spend $2, get 50% discount.
													</div>
												</div>
												<div
													style="
														width: 100%;
														margin: 6% 0;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.discount.discount"
														:class="movefield == 'discount' ? 'images' : ''"
														:src="ruleForm.discount.discount"
														:style="
															'display: block; opacity: ' +
															ruleForm.discount.discountTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														height: 50px;
														background-color: #d3dce6;
													"></div>
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.discount.next"
														:class="movefield == 'next' ? 'images' : ''"
														:src="ruleForm.discount.next"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.discount.nextTransparent +
															';'
														" />
													<img
														v-if="ruleForm.discount.back"
														:class="movefield == 'back' ? 'images' : ''"
														:src="ruleForm.discount.back"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.discount.backTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-if="CurrentCard == 5">
									<div
										style="width: 100%; overflow-y: scroll; position: relative">
										<!-- 顶部分类 -->
										<div
											style="
												width: 100%;
												display: flow-root;
												position: relative;
											">
											<img
												src="../../../assets/img/ad.jpg"
												style="width: 100%; height: 180px; display: block" />
											<div
												style="
													width: 100%;
													display: flex;
													height: 50px;
													line-height: 50px;
													text-align: center;
													border-radius: 10px 10px 0 0;
													background-color: #efefef;
													position: absolute;
													bottom: -30px;
												">
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													ALL
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													FOOD
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													DRINKS
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													JUICE
												</div>
												<div
													style="width: 20%; height: 50px; line-height: 50px">
													MILK
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="width: 100%; display: flow-root; margin-top: 30px">
											<!-- 139.38px -->
											<div
												:class="movefield == 'background' ? 'images' : ''"
												:style="
													ruleForm.goodsShow.background
														? 'background: url(' +
														ruleForm.goodsShow.background +
														'); opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center;'
														: 'background: #e5e9f2; opacity: ' +
														ruleForm.goodsShow.backgroundTransparent +
														'; display: flex; width: 100%; height: 189px;'
												">
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 162px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex; height: 25px">
															<img
																v-if="ruleForm.goodsShow.cartBtn"
																:class="movefield == 'cartBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.cartBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.cartBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																"></div>
															<img
																v-if="ruleForm.goodsShow.buyBtn"
																:class="movefield == 'buyBtn' ? 'images' : ''"
																:src="ruleForm.goodsShow.buyBtn"
																:style="
																	'width: 50%; height: 25px; display: block; opacity: ' +
																	ruleForm.goodsShow.buyBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 50%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 4px 0 0 4px;
																"></div>
														</div>
													</div>
												</div>
												<div style="width: 169px">
													<img
														v-if="ruleForm.goodsShow.productTop"
														:class="movefield == 'productTop' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTop"
														:style="
															'width: 70px; height: 25px; display: block; margin: 0 auto; opacity: ' +
															ruleForm.goodsShow.productTopTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 70px;
															height: 25px;
															display: block;
															margin: 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 40px;
															height: 75px;
															background-color: #d3dce6;
															border-radius: 3px;
															margin: 0 auto;
														">
														<img
															v-if="ruleForm.goodsShow.sellOutLabel"
															:class="
																movefield == 'sellOutLabel' ? 'images' : ''
															"
															:src="ruleForm.goodsShow.sellOutLabel"
															:style="
																'width: 54px; height: 37px; display: block; margin-left: -7px; padding-top: 15px; opacity: ' +
																ruleForm.goodsShow.sellOutLabelTransparent +
																';'
															" />
														<div
															v-else
															style="
																width: 54px;
																height: 37px;
																margin-left: -7px;
																padding-top: 15px;
																background-color: #d3dce6;
																border-radius: 3px;
															"></div>
													</div>
													<img
														v-if="ruleForm.goodsShow.productTray"
														:class="movefield == 'productTray' ? 'images' : ''"
														:src="ruleForm.goodsShow.productTray"
														:style="
															'width: 57px; height: 20px; display: block; margin: 7px auto 0 auto; opacity: ' +
															ruleForm.goodsShow.productTrayTransparent +
															';'
														" />
													<div
														v-else
														style="
															width: 57px;
															height: 20px;
															display: block;
															margin: 7px auto 0 auto;
															background-color: #d3dce6;
															border-radius: 3px;
														"></div>
													<div
														style="
															width: 90px;
															height: 43px;
															background-color: var(--vtm-surface);
															margin: 13px auto 0 auto;
															text-align: center;
															border-radius: 3px;
														">
														<div style="font-size: 10px; height: 18px">
															&nbsp;
														</div>
														<div style="display: flex">
															<img
																v-if="ruleForm.goodsShow.sellOutBtn"
																:class="
																	movefield == 'sellOutBtn' ? 'images' : ''
																"
																:src="ruleForm.goodsShow.sellOutBtn"
																:style="
																	'width: 100%; height: 25px; display: block; margin: 0px 2px; opacity: ' +
																	ruleForm.goodsShow.sellOutBtnTransparent +
																	';'
																" />
															<div
																v-else
																style="
																	width: 100%;
																	height: 25px;
																	display: block;
																	background-color: #d3dce6;
																	border-radius: 0 4px 4px 0;
																	margin: 0px 2px;
																"></div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 836px;
												background-color: #000000;
												top: 80px;
												opacity: 0.3;
												z-index: 2;
											"></div>
										<div
											style="
												position: fixed;
												width: 506px;
												height: 626px;
												background: none;
												top: 290px;
												z-index: 3;
											">
											<div
												style="
													width: 92%;
													height: 100%;
													background-color: var(--vtm-surface);
													padding: 4%;
													border-radius: 15px 15px 0 0;
												">
												<!-- 顶部 -->
												<div
													style="
														width: 100%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.cancelBtn"
														:class="movefield == 'cancelBtn' ? 'images' : ''"
														:src="ruleForm.age.cancelBtn"
														:style="
															'display: block; height: 32px; opacity: ' +
															ruleForm.age.cancelBtnTransparent +
															';'
														" />
													<div
														style="
															width: 87%;
															height: 32px;
															margin: 0 3%;
															background-color: #d3dce6;
														"></div>
												</div>
												<!-- 过程图 -->
												<div
													style="
														width: 100%;
														height: 57px;
														margin-top: 8%;
														position: relative;
														display: flex;
														align-items: center;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.progressBarTip"
														:class="
															movefield == 'progressBarTip' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarTip"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarTipTransparent +
															';'
														" />
													<div
														style="
															width: 10%;
															height: 0;
															border-bottom: dotted 2px #ccc;
															margin: 0 3px;
															opacity: 0.7;
														"></div>
													<img
														v-if="ruleForm.age.progressBarGray"
														:class="
															movefield == 'progressBarGray' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarGray"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarGrayTransparent +
															';'
														" />
													<div
														style="
															width: 10%;
															height: 0;
															border-bottom: dotted 2px #ccc;
															margin: 0 3px;
															opacity: 0.7;
														"></div>
													<img
														v-if="ruleForm.age.progressBarSuccess"
														:class="
															movefield == 'progressBarSuccess' ? 'images' : ''
														"
														:src="ruleForm.age.progressBarSuccess"
														:style="
															'width: 57px; display: block; opacity: ' +
															ruleForm.age.progressBarSuccessTransparent +
															';'
														" />
												</div>
												<div
													style="
														width: 100%;
														height: 100px;
														background-color: #d3dce6;
														margin-top: 8%;
													"></div>
												<!-- 二维码等刷卡提示 -->
												<div
													style="
														width: 100%;
														margin-top: 6%;
														display: flex;
														justify-content: space-evenly;
													">
													<img
														v-if="ruleForm.age.qrCodeTip"
														:class="movefield == 'qrCodeTip' ? 'images' : ''"
														:src="ruleForm.age.qrCodeTip"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.qrCodeTipTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.qrCodeTip"
														:class="movefield == 'qrCodeTip' ? 'images' : ''"
														:src="ruleForm.age.qrCodeTip"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.qrCodeTipTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.cardTip2"
														:class="movefield == 'cardTip2' ? 'images' : ''"
														:src="ruleForm.age.cardTip2"
														:style="
															'width: 30%; display: block; opacity: ' +
															ruleForm.age.cardTip2Transparent +
															';'
														" />
												</div>
												<!-- 成功、失败 -->
												<div
													style="
														width: 100%;
														margin-top: 2%;
														display: flex;
														justify-content: space-evenly;
													">
													<img
														v-if="ruleForm.age.successIcon"
														:class="movefield == 'successIcon' ? 'images' : ''"
														:src="ruleForm.age.successIcon"
														:style="
															'width: 20%; display: block; opacity: ' +
															ruleForm.age.successIconTransparent +
															';'
														" />
													<img
														v-if="ruleForm.age.failIcon"
														:class="movefield == 'failIcon' ? 'images' : ''"
														:src="ruleForm.age.failIcon"
														:style="
															'width: 20%; display: block; opacity: ' +
															ruleForm.age.failIconTransparent +
															';'
														" />
												</div>
												<!-- 去购买 -->
												<div
													style="
														width: 100%;
														margin-top: 4%;
														display: flex;
														justify-content: center;
													">
													<img
														v-if="ruleForm.age.goShopping"
														:class="movefield == 'goShopping' ? 'images' : ''"
														:src="ruleForm.age.goShopping"
														:style="
															'width: 50%; display: block; opacity: ' +
															ruleForm.age.goShoppingTransparent +
															';'
														" />
												</div>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<div
					slot="footer"
					class="dialog-footer"
					style="padding-top: 0 !important">
					<el-button size="small" @click="handleCloseAddEditTheme">{{
						$t("common.close")
					}}</el-button>
					<el-button
						size="small"
						type="primary"
						:disabled="SubmiTheme"
						@click="handleSubmitSaveTheme('ruleForm')"
						>{{ $t("common.definite") }}</el-button
					>
				</div>
			</el-dialog>

			<theme-machine-dialog
				:visible.sync="ShowThemeMachine"
				:loading-zhuti-machine="LoadingZhutiMachine"
				:machine-data="MachineData"
				:theme-machine-page="ThemeMachinePage"
				@add-machine="handleAddMachine"
				@remove-machine="handleRemoveMachine"
				@selection-machine="handleSelectionMachine"
				@theme-machine-page-change="LoadThemeMachineData"></theme-machine-dialog>

			<theme-add-machine-dialog
				:visible.sync="ShowAddMachine"
				:loading-add-machine="LoadingAddMachine"
				:add-machine-search="AddMachineSearch"
				:add-machine-data="AddMachineData"
				:add-machine-page="AddMachinePage"
				@search-add-machine="handleSearchAddMachine"
				@reset-add-machine="handleResetAddMachine"
				@bind-machine="handleBindMachine"
				@add-machine-page-change="getAddMachineList"
				@refresh="handlerRefresh"></theme-add-machine-dialog>

			<theme-change-template-dialog
				:visible.sync="changeTemplateDialog"
				:no-tips-change-template.sync="noTipsChangeTemplate"
				@confirm="handlerOkChangeTemplate"></theme-change-template-dialog>
		</div>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import config from "@/http/config";
import ThemeAddMachineDialog from "./components/ThemeAddMachineDialog";
import ThemeChangeTemplateDialog from "./components/ThemeChangeTemplateDialog";
import ThemeListTop from "./components/ThemeListTop";
import ThemeMachineDialog from "./components/ThemeMachineDialog";
export default {
	name: "themelist",
	components: {
		ThemeAddMachineDialog,
		ThemeChangeTemplateDialog,
		ThemeListTop,
		ThemeMachineDialog,
	},
	data() {
		return {
			//  加载主题列表
			LoadingTheme: false,
			ThemePage: {
				pageSize: 15,
				pageIndex: 1,
				totalSize: 0,
			},
			ThemeSearch: {
				no: "",
				name: "",
			},
			ThemeTableData: [],
			//  主题布局
			layoutIndex: 0,
			//  主题布局 - 纵向 - 竖屏
			zxlayoutset: [
				{
					value: 0,
					templateName: this.$t("edittheme.zyDefault"),
					background: "1000*380",
					sellOutLabel: "110*75",
					productTop: "200*200",
					sellOutBtn: "120*38",
					cartBtn: "60*38",
					buyBtn: "60*38",
					productTray: "120*40",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 1,
					templateName: this.$t("edittheme.zy11"),
					background: "1000*1280",
					sellOutLabel: "360*245",
					productTop: "200*200",
					sellOutBtn: "410*130",
					cartBtn: "205*130",
					buyBtn: "205*130",
					productTray: "350*115",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 2,
					templateName: this.$t("edittheme.zy21"),
					background: "1000*630",
					sellOutLabel: "218*145",
					productTop: "200*200",
					sellOutBtn: "186*55",
					cartBtn: "90*55",
					buyBtn: "90*55",
					productTray: "260*90",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 3,
					templateName: this.$t("edittheme.zy22"),
					background: "1000*630",
					sellOutLabel: "218*145",
					productTop: "200*200",
					sellOutBtn: "186*55",
					cartBtn: "90*55",
					buyBtn: "90*55",
					productTray: "260*90",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 4,
					templateName: this.$t("edittheme.zy23"),
					background: "1000*630",
					sellOutLabel: "218*145",
					productTop: "200*200",
					sellOutBtn: "186*55",
					cartBtn: "90*55",
					buyBtn: "90*55",
					productTray: "260*90",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 5,
					templateName: this.$t("edittheme.zy33"),
					background: "1000*380",
					sellOutLabel: "110*75",
					productTop: "200*200",
					sellOutBtn: "120*38",
					cartBtn: "60*38",
					buyBtn: "60*38",
					productTray: "120*40",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 6,
					templateName: this.$t("edittheme.zy34"),
					background: "1000*380",
					sellOutLabel: "110*75",
					productTop: "200*200",
					sellOutBtn: "120*38",
					cartBtn: "60*38",
					buyBtn: "60*38",
					productTray: "120*40",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 7,
					templateName: this.$t("edittheme.zy36"),
					background: "1000*380",
					sellOutLabel: "110*75",
					productTop: "200*200",
					sellOutBtn: "120*38",
					cartBtn: "60*38",
					buyBtn: "60*38",
					productTray: "120*40",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 8,
					templateName: this.$t("edittheme.zyg22"),
					background: "1000*630",
					sellOutLabel: "218*145",
					productTop: "200*200",
					sellOutBtn: "186*55",
					cartBtn: "90*55",
					buyBtn: "90*55",
					productTray: "260*90",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 9,
					templateName: this.$t("edittheme.zyg23"),
					background: "1000*630",
					sellOutLabel: "218*145",
					productTop: "200*200",
					sellOutBtn: "186*55",
					cartBtn: "90*55",
					buyBtn: "90*55",
					productTray: "260*90",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 10,
					templateName: this.$t("edittheme.zyg33"),
					background: "1000*380",
					sellOutLabel: "110*75",
					productTop: "200*200",
					sellOutBtn: "120*38",
					cartBtn: "60*38",
					buyBtn: "60*38",
					productTray: "120*40",
					cartBackground: "400*1280",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
			],
			//  主题布局 - 横向 - 横屏
			hxlayoutset: [
				{
					value: 0,
					templateName: this.$t("edittheme.hxDefault"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 1,
					templateName: this.$t("edittheme.hx11"),
					background: "1850*1030",
					sellOutLabel: "300*205",
					productTop: "200*200",
					sellOutBtn: "420*130",
					cartBtn: "210*130",
					buyBtn: "210*130",
					productTray: "290*100",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 2,
					templateName: this.$t("edittheme.hx12"),
					background: "1850*1030",
					sellOutLabel: "300*205",
					productTop: "200*200",
					sellOutBtn: "420*130",
					cartBtn: "210*130",
					buyBtn: "210*130",
					productTray: "290*100",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 3,
					templateName: this.$t("edittheme.hx22"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 4,
					templateName: this.$t("edittheme.hx23"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 5,
					templateName: this.$t("edittheme.hx24"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 6,
					templateName: this.$t("edittheme.hxg12"),
					background: "1850*1030",
					sellOutLabel: "300*205",
					productTop: "200*200",
					sellOutBtn: "420*130",
					cartBtn: "210*130",
					buyBtn: "210*130",
					productTray: "290*100",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 7,
					templateName: this.$t("edittheme.hxg22"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 8,
					templateName: this.$t("edittheme.hxg23"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
				{
					value: 9,
					templateName: this.$t("edittheme.hxg24"),
					background: "1850*510",
					sellOutLabel: "140*95",
					productTop: "200*200",
					sellOutBtn: "210*70",
					cartBtn: "105*70",
					buyBtn: "105*70",
					productTray: "145*50",
					cartBackground: "350*510",
					cartIcon: "45*40",
					delBtn: "27*27",
					add: "29*29",
					reduce: "29*29",
					reduceUnavailable: "29*29",
					cartClear: "150*60",
					buyBtnC: "150*60",
					qrCodeBtn: "320*320 / 320*320",
					cashBtn: "580*170 / 320*320",
					coinBtn: "580*170 / 320*320",
					creditCardBtn: "580*170 / 320*320",
					couponBtn: "85*65",
					closeBtn: "85*65",
					qrCodeImg: "100*100 / 160*160 / 250*250",
					cashImg: "100*100 / 160*160 / 250*250",
					coinImg: "100*100 / 160*160 / 250*250",
					creditCardImg: "100*100 / 160*160 / 250*250",
					successIcon: "80*80",
					failIcon: "80*80",
					buyAgain: "400*140",
					buyFail: "400*400",
					stockUp: "400*400",
					sell: "400*400",
					load: "60*60",
					next: "150*60",
					back: "150*60",
					discount: "200*200",
				},
			],
			template: [],
			//  添加/编辑主题
			movefield: "",
			ThemeType: 0,
			ShowEditTheme: false,
			screen: "Portrait",
			ruleForm: {
				id: "",
				name: "",
				color: "#FF9D19",
				mould: "",
				screen: 2,
				fontColor: {
					price: "#FF9D19",
					text: "#555555",
					content: "#555555",
					other: "#D7D7D7",
					btnText: "#4B3C3C",
				},
				backColor: {
					back: "#FF9D19",
					popup: "#555555",
					label: "#555555",
					productTag: "#D7D7D7",
				},
				goodsShow: {
					background: "",
					backgroundTransparent: 0,
					sellOutLabel: "",
					sellOutLabelTransparent: 0,
					sellOutBtn: "",
					sellOutBtnTransparent: 0,
					productTop: "",
					productTopTransparent: 0,
					productTray: "",
					productTrayTransparent: 0,
					cartBtn: "",
					cartBtnTransparent: 0,
					buyBtn: "",
					buyBtnTransparent: 0,
				},
				cart: {
					background: "",
					backgroundTransparent: 0,
					cartIcon: "",
					cartIconTransparent: 0,
					delBtn: "",
					delBtnTransparent: 0,
					add: "",
					addTransparent: 0,
					reduce: "",
					reduceTransparent: 0,
					reduceUnavailable: "",
					reduceUnavailableTransparent: 0,
					cartClear: "",
					cartClearTransparent: 0,
					buyBtn: "",
					buyBtnTransparent: 0,
				},
				pay: {
					qrCodeBtn: "",
					qrCodeBtnTransparent: 0,
					cashBtn: "",
					cashBtnTransparent: 0,
					coinBtn: "",
					coinBtnTransparent: 0,
					creditCardBtn: "",
					creditCardBtnTransparent: 0,
					couponBtn: "",
					couponBtnTransparent: 0,
					closeBtn: "",
					closeBtnTransparent: 0,
					qrCodeImg: "",
					qrCodeImgTransparent: 0,
					cashImg: "",
					cashImgTransparent: 0,
					coinImg: "",
					coinImgTransparent: 0,
					creditCardImg: "",
					creditCardImgTransparent: 0,
					isEnable: false,
					fontSize: "",
					priceFontSize: "",
					priceFontColor: "",
					fontColor: "",
					qrCodeText: "",
					cashText: "",
					creditCardText: "",
					coinText: "",
				},
				buy: {
					successIcon: "",
					successIconTransparent: 0,
					failIcon: "",
					failIconTransparent: 0,
					buyAgain: "",
					buyAgainTransparent: 0,
					buyFail: "",
					buyFailTransparent: 0,
					stockUp: "",
					stockUpTransparent: 0,
					sell: "",
					sellTransparent: 0,
					load: "",
					loadTransparent: 0,
				},
				discount: {
					next: "",
					nextTransparent: 0,
					back: "",
					backTransparent: 0,
					discount: "",
					discountTransparent: 0,
				},
				age: {},
				all: {
					bottomLabel: "0", //底部信息标签自定义
					hideSystemText: "0", //隐藏系统文字
					hideSystemColor: "#000000", //隐藏系统文字颜色
					bottomLabelImg: "", //底部信息标签图
					bottomLabelImgTransparent: "1", //底部信息标签图透明度
				},
			},
			SubmiTheme: false,
			CurrentCard: 0,
			action: config.baseUrl + this.$url.Upload.theme,
			headers() {
				return { token: this.token };
			},
			//  主题设备
			ShowThemeMachine: false,
			LoadingZhutiMachine: false,
			ThemeMachineSearch: {
				styleId: 0,
			},
			ThemeMachinePage: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			MachineData: [],
			SelectionMachine: [],
			//  添加设备
			Refresh: 0,
			ShowAddMachine: false,
			LoadingAddMachine: false,
			AddMachineSearch: {
				equipmentNo: "",
				equipmentName: "",
				teamName: "",
			},
			AddMachinePage: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			AddMachineData: [],
			// 更改模块时温馨提示
			changeTemplateDialog: false,
			noTipsChangeTemplate: "0",
			tempValue: null,
			LoadingEditTheme: false,
		};
	},
	computed: {
		...mapGetters(["token"])
	},
	mounted() {
		let _self = this;
		//  加载主题列表
		_self.LoadCurrentThemeData();
		// 查询是否不再提醒
		this.noTipsChangeTemplate =
			localStorage.getItem("noTipsChangeTemplate") || "0";
	},
	methods: {
		beforeUploadGif(file) {
			// 检查文件类型是否为 gif
			const isGif = file.type === "image/gif";
			if (!isGif) {
				this.$message.error(this.$t('theme.list.767480-7'));
			}
			return isGif; // 返回 false 会停止上传
		},
		// 切换横屏/竖屏时index归0
		handlerChangeDirection() {
			this.layoutIndex = 0;
			this.GetDefaultTheme();
		},
		LoadCurrentSizeChange(pageSize) {
			this.ThemePage.pageSize = pageSize;
			this.LoadCurrentThemeData();
		},

		//  加载主题列表
		LoadCurrentThemeData(pageIndex) {
			let _self = this;
			_self.LoadingTheme = true;
			_self.ThemePage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(_self.ThemeSearch, _self.ThemePage);
			_self.$api
				.request(_self.$url.Theme.themepage, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						let records = res.data.records;
						for (let i = 0; i < records.length; i++) {
							let userMachineStr = "";
							if (records[i]["userEquipment"]) {
								let userEquipment = records[i]["userEquipment"];
								for (let j = 0; j < userEquipment.length; j++) {
									if (!userMachineStr) {
										userMachineStr = userEquipment[j]["name"];
									} else {
										if (j < 6) {
											if (j == 5) {
												userMachineStr += "、...";
											} else {
												userMachineStr += "、" + userEquipment[j]["name"];
											}
										}
									}
								}
							}
							records[i]["userMachineStr"] = userMachineStr;
						}
						_self.ThemeTableData = records;
						_self.ThemePage.totalSize = parseInt(res.data.total);
					}
					_self.LoadingTheme = false;
				})
				.catch(() => {
					_self.LoadingTheme = false;
				});
		},
		//  切换布局
		handlerSwitchLayout(value) {
			if (this.noTipsChangeTemplate == "0") {
				//展示询问框
				this.tempValue = value;
				this.changeTemplateDialog = true;
			} else {
				// 不展示询问框
				this.ruleForm.mould = value;
				this.layoutIndex = value;
				this.GetDefaultTheme();
			}
		},
		// 修改主题模板温馨提示确认按钮
		handlerOkChangeTemplate() {
			this.ruleForm.mould = this.tempValue;
			this.layoutIndex = this.tempValue;
			this.GetDefaultTheme();
			// 判断是否选择不再提醒
			if (this.noTipsChangeTemplate == "1") {
				localStorage.setItem("noTipsChangeTemplate", "1");
			}
			this.changeTemplateDialog = false;
		},
		//  格式化订单状态内容
		formatterThemeTemplate(row) {
			if (row.screen == 2) {
				//竖屏 mould
				return this.zxlayoutset.filter(item => item.value == row.mould)[0]
					.templateName;
			} else {
				//横屏 mould
				return this.hxlayoutset.filter(item => item.value == row.mould)[0]
					.templateName;
			}
		},
		//  搜索主题列表
		handleSearchTheme() {
			let _self = this;
			_self.LoadCurrentThemeData();
		},
		//  重置主题搜索
		handleResetTheme() {
			let _self = this;
			_self.ThemeSearch.no = "";
			_self.ThemeSearch.name = "";
			_self.ThemePage.pageIndex = 1;
			_self.LoadCurrentThemeData();
		},
		//  删除主题列表
		handleDeleteTheme(id) {
			let _self = this;
			_self
				.$confirm(_self.$t("edittheme.deleteTips"), _self.$t("common.tip"), {
					confirmButtonText: _self.$t("common.definite"),
					cancelButtonText: _self.$t("common.cancel"),
					type: "warning",
				})
				.then(() => {
					_self.$api
						.request(_self.$url.Theme.themedelete, _self.$method.delete, {
							id: id,
						})
						.then(res => {
							if (res.code == 0) {
								_self.$message({
									type: "success",
									message: this.$t("edittheme.deleteSuccess"),
								});
								_self.ThemePage.pageIndex = 1;
								_self.LoadCurrentThemeData();
							} else {
								_self.$message({
									type: "error",
									message: res.msg,
								});
							}
						})
						.catch(res => {
							_self.$message({
								type: "error",
								message: JSON.stringify(res),
							});
						});
				})
				.catch(() => {});
		},
		//  添加或编辑主题
		handleAddEditTheme(ThemeType, item = null) {
			let _self = this;
			_self.ThemeType = ThemeType;
			if (item) {
				_self.ruleForm = JSON.parse(JSON.stringify(item));

				if (parseInt(_self.ruleForm.screen) == 1) {
					_self.screen = "Landscape";
				} else if (parseInt(_self.ruleForm.screen) == 2) {
					_self.screen = "Portrait";
				} else {
					_self.screen = "Portrait";
				}

				if (!_self.ruleForm.all) {
					_self.ruleForm.all = {
						bottomLabel: "0", //底部信息标签自定义
						hideSystemText: "0", //隐藏系统文字
						hideSystemColor: "#000000", //隐藏系统文字颜色
						bottomLabelImg: "", //底部信息标签图
						bottomLabelImgTransparent: "1", //底部信息标签图透明度
					};
				}
				_self.layoutIndex = _self.ruleForm.mould;
			} else {
				//  获取默认主题
				_self.GetDefaultTheme("open");
			}

			_self.ShowEditTheme = true;
		},
		// 获取默认主题
		GetDefaultTheme(status) {
			let _self = this;
			_self.LoadingEditTheme = true;
			let url = "";
			// 是admin 且 第一次打开请求默认 其他的请求其他样式
			if (_self.ThemeType == "admin" && status === "open") {
				url = _self.$url.Theme.getAdmin;
			} else {
				url = _self.$url.Theme.getDefault;
			}
			_self.$api
				.request(url, _self.$method.get, {
					screen: this.screen == "Portrait" ? 2 : 1,
					mould: this.layoutIndex,
				})
				.then(res => {
					if (res.code === 0) {
						let id = _self.ruleForm.id;
						let datas = res.data;
						delete datas.no;

						if (parseInt(datas.screen) == 1) {
							_self.screen = "Landscape";
						} else if (parseInt(datas.screen) == 2) {
							_self.screen = "Portrait";
						} else {
							_self.screen = "Portrait";
						}
						_self.layoutIndex = parseInt(datas.mould);
						_self.ruleForm = datas;
						_self.ruleForm.id = id;
					} else {
						_self.layoutIndex = 0;
						_self.ruleForm = {
							id: 0,
							name: "",
							color: "#FF9D19",
							mould: 0,
							screen: 2,
							backColor: {
								back: "",
								label: "",
								popup: "",
								productTag: "",
							},
							fontColor: {
								price: "#FF9D19",
								text: "#555555",
								content: "#555555",
								other: "#D7D7D7",
								btnText: "#4B3C3C",
							},
							goodsShow: {
								background: "",
								backgroundTransparent: 0,
								sellOutLabel: "",
								sellOutLabelTransparent: 0,
								sellOutBtn: "",
								sellOutBtnTransparent: 0,
								productTop: "",
								productTopTransparent: 0,
								productTray: "",
								productTrayTransparent: 0,
								cartBtn: "",
								cartBtnTransparent: 0,
								buyBtn: "",
								buyBtnTransparent: 0,
							},
							cart: {
								background: "",
								backgroundTransparent: 0,
								cartIcon: "",
								cartIconTransparent: 0,
								delBtn: "",
								delBtnTransparent: 0,
								add: "",
								addTransparent: 0,
								reduce: "",
								reduceTransparent: 0,
								reduceUnavailable: "",
								reduceUnavailableTransparent: 0,
								cartClear: "",
								cartClearTransparent: 0,
								buyBtn: "",
								buyBtnTransparent: 0,
							},
							pay: {
								qrCodeBtn: "",
								qrCodeBtnTransparent: 0,
								cashBtn: "",
								cashBtnTransparent: 0,
								coinBtn: "",
								coinBtnTransparent: 0,
								creditCardBtn: "",
								creditCardBtnTransparent: 0,
								couponBtn: "",
								couponBtnTransparent: 0,
								closeBtn: "",
								closeBtnTransparent: 0,
								qrCodeImg: "",
								qrCodeImgTransparent: 0,
								cashImg: "",
								cashImgTransparent: 0,
								coinImg: "",
								coinImgTransparent: 0,
								creditCardImg: "",
								creditCardImgTransparent: 0,
								isEnable: false,
								fontSize: "",
								priceFontSize: "",
								priceFontColor: "",
								fontColor: "",
								qrCodeText: "",
								cashText: "",
								creditCardText: "",
								coinText: "",
							},
							buy: {
								successIcon: "",
								successIconTransparent: 0,
								failIcon: "",
								failIconTransparent: 0,
								buyAgain: "",
								buyAgainTransparent: 0,
								buyFail: "",
								buyFailTransparent: 0,
								stockUp: "",
								stockUpTransparent: 0,
								sell: "",
								sellTransparent: 0,
								load: "",
								loadTransparent: 0,
							},
							discount: {
								next: "",
								nextTransparent: 0,
								back: "",
								backTransparent: 0,
								discount: "",
								discountTransparent: 0,
							},
							age: {},
							all: {
								bottomLabel: "0", //底部信息标签自定义
								hideSystemText: "0", //隐藏系统文字
								hideSystemColor: "#000000", //隐藏系统文字颜色
								bottomLabelImg: "", //底部信息标签图
								bottomLabelImgTransparent: "1", //底部信息标签图透明度
							},
						};
					}
				})
				.catch(() => {
					_self.layoutIndex = 0;
					_self.ruleForm = {
						id: 0,
						name: "",
						color: "#FF9D19",
						mould: 0,
						screen: 2,
						backColor: {
							back: "",
							label: "",
							popup: "",
							productTag: "",
						},
						fontColor: {
							price: "#FF9D19",
							text: "#555555",
							content: "#555555",
							other: "#D7D7D7",
							btnText: "#4B3C3C",
						},
						goodsShow: {
							background: "",
							backgroundTransparent: 0,
							sellOutLabel: "",
							sellOutLabelTransparent: 0,
							sellOutBtn: "",
							sellOutBtnTransparent: 0,
							productTop: "",
							productTopTransparent: 0,
							productTray: "",
							productTrayTransparent: 0,
							cartBtn: "",
							cartBtnTransparent: 0,
							buyBtn: "",
							buyBtnTransparent: 0,
						},
						cart: {
							background: "",
							backgroundTransparent: 0,
							cartIcon: "",
							cartIconTransparent: 0,
							delBtn: "",
							delBtnTransparent: 0,
							add: "",
							addTransparent: 0,
							reduce: "",
							reduceTransparent: 0,
							reduceUnavailable: "",
							reduceUnavailableTransparent: 0,
							cartClear: "",
							cartClearTransparent: 0,
							buyBtn: "",
							buyBtnTransparent: 0,
						},
						pay: {
							qrCodeBtn: "",
							qrCodeBtnTransparent: 0,
							cashBtn: "",
							cashBtnTransparent: 0,
							coinBtn: "",
							coinBtnTransparent: 0,
							creditCardBtn: "",
							creditCardBtnTransparent: 0,
							couponBtn: "",
							couponBtnTransparent: 0,
							closeBtn: "",
							closeBtnTransparent: 0,
							qrCodeImg: "",
							qrCodeImgTransparent: 0,
							cashImg: "",
							cashImgTransparent: 0,
							coinImg: "",
							coinImgTransparent: 0,
							creditCardImg: "",
							creditCardImgTransparent: 0,
							isEnable: false,
							fontSize: "",
							priceFontSize: "",
							fontColor: "",
							qrCodeText: "",
							cashText: "",
							creditCardText: "",
							coinText: "",
						},
						buy: {
							successIcon: "",
							successIconTransparent: 0,
							failIcon: "",
							failIconTransparent: 0,
							buyAgain: "",
							buyAgainTransparent: 0,
							buyFail: "",
							buyFailTransparent: 0,
							stockUp: "",
							stockUpTransparent: 0,
							sell: "",
							sellTransparent: 0,
							load: "",
							loadTransparent: 0,
						},
						discount: {
							next: "",
							nextTransparent: 0,
							back: "",
							backTransparent: 0,
							discount: "",
							discountTransparent: 0,
						},
						age: {},
					};
				})
				.finally(() => {
					_self.LoadingEditTheme = false;
				});
		},
		//  隐藏添加或编辑主题
		handleCloseAddEditTheme() {
			let _self = this;
			_self.SubmiTheme = false;
			_self.ShowEditTheme = false;
		},
		//  提交保存主题
		handleSubmitSaveTheme() {
			let _self = this;
			if (!_self.ruleForm.name) {
				_self.$message({
					message: _self.$t("edittheme.names"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.mainTone) {
				_self.$message({
					message: _self.$t("edittheme.colors"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.backColor.back) {
				_self.$message({
					message: this.$t('theme.list.767480-9'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.backColor.popup) {
				_self.$message({
					message: this.$t('theme.list.767480-10'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.backColor.label) {
				_self.$message({
					message: this.$t('theme.list.767480-11'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.backColor.productTag) {
				_self.$message({
					message: this.$t('theme.list.767480-12'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.fontColor.price) {
				_self.$message({
					message: this.$t('theme.list.767480-13'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.fontColor.text) {
				_self.$message({
					message: this.$t('theme.list.767480-14'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.fontColor.content) {
				_self.$message({
					message: this.$t('theme.list.767480-15'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.fontColor.other) {
				_self.$message({
					message: this.$t('theme.list.767480-16'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.fontColor.btnText) {
				_self.$message({
					message: this.$t('theme.list.767480-17'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.background) {
				_self.$message({
					message: _self.$t("edittheme.backgrounds"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.sellOutLabel) {
				_self.$message({
					message: _self.$t("edittheme.sellOutLabels"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.productTop) {
				_self.$message({
					message: _self.$t("edittheme.productTops"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.sellOutBtn) {
				_self.$message({
					message: _self.$t("edittheme.sellOutBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.cartBtn) {
				_self.$message({
					message: _self.$t("edittheme.cartBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.buyBtn) {
				_self.$message({
					message: _self.$t("edittheme.buyBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.goodsShow.productTray) {
				_self.$message({
					message: _self.$t("edittheme.productTrays"),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.goodsShow.isEnable == 1 &&
				!_self.ruleForm.goodsShow.priceFontSize
			) {
				_self.$message({
					message: this.$t('theme.list.767480-18'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.goodsShow.isEnable == 1 &&
				!_self.ruleForm.goodsShow.priceFontColor
			) {
				_self.$message({
					message: this.$t('theme.list.767480-19'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.goodsShow.isEnable == 1 &&
				!_self.ruleForm.goodsShow.nameFontSize
			) {
				_self.$message({
					message: this.$t('theme.list.767480-20'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.goodsShow.isEnable == 1 &&
				!_self.ruleForm.goodsShow.nameFontColor
			) {
				_self.$message({
					message: this.$t('theme.list.767480-21'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.background) {
				_self.$message({
					message: _self.$t("edittheme.cartBackgrounds"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.cartIcon) {
				_self.$message({
					message: _self.$t("edittheme.cartIcons"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.delBtn) {
				_self.$message({
					message: _self.$t("edittheme.delBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.add) {
				_self.$message({
					message: _self.$t("edittheme.adds"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.reduce) {
				_self.$message({
					message: _self.$t("edittheme.reduces"),
					type: "warning",
				});
				return false;
			}

			if (!_self.ruleForm.cart.cartClear) {
				_self.$message({
					message: _self.$t("edittheme.cartClears"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.cart.buyBtn) {
				_self.$message({
					message: _self.$t("edittheme.buyBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.qrCodeBtn) {
				_self.$message({
					message: _self.$t("edittheme.qrCodeBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.cashBtn) {
				_self.$message({
					message: _self.$t("edittheme.cashBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.coinBtn) {
				_self.$message({
					message: _self.$t("edittheme.coinBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.creditCardBtn) {
				_self.$message({
					message: _self.$t("edittheme.creditCardBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.couponBtn) {
				_self.$message({
					message: _self.$t("edittheme.couponBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.closeBtn) {
				_self.$message({
					message: _self.$t("edittheme.closeBtns"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.qrCodeImg) {
				_self.$message({
					message: _self.$t("edittheme.qrCodeImgs"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.cashImg) {
				_self.$message({
					message: _self.$t("edittheme.cashImgs"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.coinImg) {
				_self.$message({
					message: _self.$t("edittheme.coinImgs"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.pay.creditCardImg) {
				_self.$message({
					message: _self.$t("edittheme.creditCardImgs"),
					type: "warning",
				});
				return false;
			}
			if (_self.ruleForm.pay.isEnable == 1 && !_self.ruleForm.pay.fontSize) {
				_self.$message({
					message: this.$t('theme.list.767480-22'),
					type: "warning",
				});
				return false;
			}
			if (_self.ruleForm.pay.isEnable == 1 && !_self.ruleForm.pay.fontColor) {
				_self.$message({
					message: this.$t('theme.list.767480-23'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.pay.isEnable == 1 &&
				!_self.ruleForm.pay.priceFontSize
			) {
				_self.$message({
					message: this.$t('theme.list.767480-24'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.pay.isEnable == 1 &&
				!_self.ruleForm.pay.priceFontColor
			) {
				_self.$message({
					message: this.$t('theme.list.767480-13'),
					type: "warning",
				});
				return false;
			}
			if (_self.ruleForm.pay.isEnable == 1 && !_self.ruleForm.pay.qrCodeText) {
				_self.$message({
					message: this.$t('theme.list.767480-25'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.pay.isEnable == 1 &&
				!_self.ruleForm.pay.creditCardText
			) {
				_self.$message({
					message: this.$t('theme.list.767480-26'),
					type: "warning",
				});
				return false;
			}
			if (_self.ruleForm.pay.isEnable == 1 && !_self.ruleForm.pay.cashText) {
				_self.$message({
					message: this.$t('theme.list.767480-27'),
					type: "warning",
				});
				return false;
			}
			if (_self.ruleForm.pay.isEnable == 1 && !_self.ruleForm.pay.coinText) {
				_self.$message({
					message: this.$t('theme.list.767480-28'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.successIcon) {
				_self.$message({
					message: _self.$t("edittheme.successIcons"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.failIcon) {
				_self.$message({
					message: _self.$t("edittheme.failIcons"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.buyAgain) {
				_self.$message({
					message: _self.$t("edittheme.buyAgains"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.buyFail) {
				_self.$message({
					message: _self.$t("edittheme.buyFails"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.stockUp) {
				_self.$message({
					message: _self.$t("edittheme.stockUps"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.sell) {
				_self.$message({
					message: _self.$t("edittheme.sells"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.buy.load) {
				_self.$message({
					message: _self.$t("edittheme.loads"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.cancelBtn) {
				_self.$message({
					message: this.$t('theme.list.767480-29'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.cancelBtn) {
				_self.$message({
					message: this.$t('theme.list.767480-29'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.successIcon) {
				_self.$message({
					message: this.$t('theme.list.767480-30'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.failIcon) {
				_self.$message({
					message: this.$t('theme.list.767480-31'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.qrCodeTip) {
				_self.$message({
					message: this.$t('theme.list.767480-32'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.cardTip1) {
				_self.$message({
					message: this.$t('theme.list.767480-33'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.cardTip2) {
				_self.$message({
					message: this.$t('theme.list.767480-34'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.progressBarTip) {
				_self.$message({
					message: this.$t('theme.list.767480-35'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.progressBarGray) {
				_self.$message({
					message: this.$t('theme.list.767480-36'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.progressBarSuccess) {
				_self.$message({
					message: this.$t('theme.list.767480-37'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.age.goShopping) {
				_self.$message({
					message: this.$t('theme.list.767480-38'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.discount.next) {
				_self.$message({
					message: _self.$t("edittheme.nexts"),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.discount.back) {
				_self.$message({
					message: this.$t('theme.list.767480-39'),
					type: "warning",
				});
				return false;
			}
			if (!_self.ruleForm.discount.discount) {
				_self.$message({
					message: _self.$t("edittheme.discounts"),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.all.bottomLabel == "1" &&
				!_self.ruleForm.all.hideSystemColor
			) {
				_self.$message({
					message: this.$t('theme.list.767480-40'),
					type: "warning",
				});
				return false;
			}
			if (
				_self.ruleForm.all.bottomLabel == "1" &&
				!_self.ruleForm.all.bottomLabelImg
			) {
				_self.$message({
					message: this.$t('theme.list.767480-41'),
					type: "warning",
				});
				return false;
			}

			if (_self.screen == "Landscape") {
				_self.ruleForm.screen = 1;
			} else if (_self.screen == "Portrait") {
				_self.ruleForm.screen = 2;
			} else {
				_self.ruleForm.screen = 2;
			}
			_self.SubmiTheme = true;
			if (_self.ThemeType == "admin") {
				// 如果是admin默认主题
				//去除id = 0
				delete _self.ruleForm.id;
				_self.$api
					.request(
						_self.$url.Theme.adminThemeUpdate,
						_self.$method.post,
						_self.ruleForm
					)
					.then(res => {
						if (res.code == 0) {
							_self.$message({
								type: "success",
								message: this.$t("edittheme.updateSuccess"),
							});
							_self.ThemePage.pageIndex = 1;
							_self.LoadCurrentThemeData();
							_self.SubmiTheme = false;
							_self.ShowEditTheme = false;
						} else {
							_self.SubmiTheme = false;
							_self.$message({
								type: "error",
								message: res.msg,
							});
						}
					})
					.catch(res => {
						_self.SubmiTheme = false;
						_self.$message({
							type: "error",
							message: JSON.stringify(res),
						});
					});
			} else if (_self.ruleForm.id) {
				_self.$api
					.request(
						_self.$url.Theme.themeupdate,
						_self.$method.put,
						_self.ruleForm
					)
					.then(res => {
						if (res.code == 0) {
							_self.$message({
								type: "success",
								message: this.$t("edittheme.updateSuccess"),
							});
							_self.ThemePage.pageIndex = 1;
							_self.LoadCurrentThemeData();
							_self.SubmiTheme = false;
							_self.ShowEditTheme = false;
						} else {
							_self.SubmiTheme = false;
							_self.$message({
								type: "error",
								message: res.msg,
							});
						}
					})
					.catch(res => {
						_self.SubmiTheme = false;
						_self.$message({
							type: "error",
							message: JSON.stringify(res),
						});
					});
			} else {
				_self.$api
					.request(
						_self.$url.Theme.themeinsert,
						_self.$method.post,
						_self.ruleForm
					)
					.then(res => {
						if (res.code == 0) {
							_self.$message({
								type: "success",
								message: this.$t("edittheme.addSuccess"),
							});
							_self.ThemePage.pageIndex = 1;
							_self.LoadCurrentThemeData();
							_self.SubmiTheme = false;
							_self.ShowEditTheme = false;
						} else {
							_self.SubmiTheme = false;
							_self.$message({
								type: "error",
								message: res.msg,
							});
						}
					})
					.catch(res => {
						_self.SubmiTheme = false;
						_self.$message({
							type: "error",
							message: JSON.stringify(res),
						});
					});
			}
		},
		//  鼠标移入卡片
		handleMouseEnterCard(current, fields) {
			let _self = this;
			_self.movefield = fields;
			_self.CurrentCard = current;
		},
		//  鼠标移出卡片
		handleMouseLeaveCard() {
			let _self = this;
			_self.movefield = "";
		},
		// 上传文件之前的钩子
		handleBeforeUpload(response, file, fileList, field, i) {
			let _self = this;
		},
		//  文件上传成功时的钩子
		handleUploadSuccess(response, file, fileList, field, i) {
			let _self = this;
			if (response.code === 0) {
				// 0~5变量字段解释
				if (i == 0) {
					_self.ruleForm.goodsShow[field] = response.data;
				} else if (i == 1) {
					_self.ruleForm.cart[field] = response.data;
				} else if (i == 2) {
					_self.ruleForm.pay[field] = response.data;
				} else if (i == 3) {
					_self.ruleForm.buy[field] = response.data;
				} else if (i == 4) {
					_self.ruleForm.discount[field] = response.data;
				} else if (i == 5) {
					_self.ruleForm.age[field] = response.data;
				} else if (i == 6) {
					_self.ruleForm.all[field] = response.data;
				}
			}
		},

		//  主题设备按钮
		handleThemeMachine(styleId) {
			let _self = this;
			_self.ShowThemeMachine = true;
			_self.ThemeMachineSearch.styleId = styleId;
			_self.ThemeMachinePage.pageIndex = 1;
			_self.LoadThemeMachineData();
		},
		//  主题设备列表
		LoadThemeMachineData(pageIndex) {
			let _self = this;
			_self.LoadingZhutiMachine = true;
			_self.ThemeMachinePage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(
				_self.ThemeMachineSearch,
				_self.ThemeMachinePage
			);
			_self.$api
				.request(_self.$url.Theme.machineSelect, _self.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						let records = res.data.records;
						_self.MachineData = records;
						_self.ThemeMachinePage.totalSize = parseInt(res.data.total);
					}
					_self.LoadingZhutiMachine = false;
				})
				.catch(() => {
					_self.LoadingZhutiMachine = false;
				});
		},
		//  选择主题设备
		handleSelectionMachine(val) {
			let _self = this;
			_self.SelectionMachine = val;
		},
		//  移除设备
		handleRemoveMachine(type, id = "") {
			let _self = this;
			let styleId = _self.ThemeMachineSearch.styleId;
			let tips = "";
			let idset = [];
			if (id) {
				idset.push(id);
				tips = _self.$t("themelist.tipMachine");
			} else {
				if (_self.SelectionMachine.length < 1) {
					_self.$message({
						message: _self.$t("themelist.selectips"),
						type: "warning",
					});
					return false;
				}
				let SelectionMachine = _self.SelectionMachine;
				let titlestr = "";
				for (let i = 0; i < SelectionMachine.length; i++) {
					if (titlestr == "") {
						titlestr = SelectionMachine[i]["name"];
					} else {
						titlestr += "," + SelectionMachine[i]["name"];
					}
					idset.push(SelectionMachine[i]["id"]);
				}
				tips =
					_self.$t("themelist.tipsMachine") +
					" " +
					titlestr +
					" " +
					_self.$t("themelist.wenhao");
			}
			_self
				.$confirm(tips, _self.$t("common.tip"), {
					confirmButtonText: _self.$t("common.definite"),
					cancelButtonText: _self.$t("common.cancel"),
					type: "warning",
				})
				.then(() => {
					_self.$api
						.request(_self.$url.Theme.configmachine, _self.$method.post, {
							type: type,
							id: styleId,
							ids: idset,
						})
						.then(res => {
							_self.$message({
								type: "success",
								message: _self.$t("themelist.removeSuccess"),
							});
							_self.ThemeMachinePage.pageIndex = 1;
							_self.LoadThemeMachineData();
							_self.ThemePage.pageIndex = 1;
							_self.LoadCurrentThemeData();
						})
						.catch(res => {
						});
				})
				.catch(() => {});
		},

		//  添加设备
		handleAddMachine(refresh, styleId = "") {
			let _self = this;
			_self.Refresh = refresh;
			if (styleId) {
				_self.ThemeMachineSearch.styleId = styleId;
			}
			_self.getAddMachineList(1);
		},
		getAddMachineList(pageIndex) {
			let _self = this;
			_self.LoadingAddMachine = true;
			//  获取设备信息
			_self.AddMachinePage.pageIndex = pageIndex ? pageIndex : 1;
			let obj = _self.$cloud.objMerge(
				_self.AddMachineSearch,
				_self.AddMachinePage
			);
			_self.$api
				.request(_self.$url.Theme.machinepage, _self.$method.get, obj)
				.then(res => {
					_self.LoadingAddMachine = false;
					let data = res.data.records;
					for (let i = 0; i < data.length; i++) {
						data[i]["isselect"] = 0;
					}
					_self.AddMachineData = data;
					_self.AddMachinePage.totalSize = parseInt(res.data.total);
				})
				.catch(() => {
					_self.LoadingAddMachine = false;
					_self.AddMachineData = [];
				});
			_self.ShowAddMachine = true;
		},
		handleSearchAddMachine() {
			let _self = this;
			_self.getAddMachineList();
		},
		handleResetAddMachine() {
			let _self = this;
			_self.AddMachineSearch.equipmentNo = "";
			_self.AddMachineSearch.equipmentName = "";
			_self.AddMachineSearch.teamName = "";
			_self.AddMachinePage.pageIndex = 1;
			_self.getAddMachineList();
		},
		//  绑定设备
		handleBindMachine(status, id, index) {
			let _self = this;
			_self.$api
				.request(_self.$url.Theme.configmachine, _self.$method.post, {
					type: status,
					id: _self.ThemeMachineSearch.styleId,
					ids: [id],
				})
				.then(res => {
					_self.AddMachineData[index]["isselect"] = parseInt(status);
				})
				.catch(res => {
					_self.$message({
						type: "error",
						message: JSON.stringify(res),
					});
				});
		},
		handlerRefresh() {
			let _self = this;
			_self.LoadCurrentThemeData();
		},
		handlerShowConfigMachine(machines) {
			let str = "";
			if (machines && machines.length > 0) {
				machines.forEach(item => {
					str = str + item.equipmentName + ",";
				});
			}
			return str.substring(0, str.length - 1);
		},
	},
};
</script>

<style lang="scss">
.themelist {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: var(--vtm-surface);
}
.AddEditTheme .el-dialog__header {
	padding: 20px;
}
.AddEditTheme .el-dialog__footer {
	padding: 20px 0 20px 20px;
	position: fixed;
	bottom: 0;
	width: 1020px;
	background-color: var(--vtm-surface);
	z-index: 10000;
}
.AddEditTheme .el-dialog__body {
	padding: 0 20px 20px 20px !important;
	margin: 0 !important;
	height: auto;
}

.cmcMachine .el-dialog__header {
	padding: 20px;
}
.cmcMachine .el-dialog__footer {
	padding: 20px 0 20px 20px;
	position: fixed;
	bottom: 0;
	width: 1020px;
	background-color: var(--vtm-surface);
	z-index: 10000;
}
.cmcMachine .el-dialog__body {
	padding: 0 20px 20px 20px !important;
	margin: 0 !important;
	height: auto;
}

.addMachine .el-dialog__header {
	padding: 20px;
}
.addMachine .el-dialog__footer {
	padding: 20px 0 20px 20px;
	position: fixed;
	bottom: 0;
	width: 1020px;
	background-color: var(--vtm-surface);
	z-index: 10000;
}
.addMachine .el-dialog__body {
	padding: 0 20px 20px 20px !important;
	margin: 0 !important;
	height: auto;
}

.el-input-number--mini .el-input__inner {
	padding-left: 30px;
	padding-right: 30px;
}

.el-form--label-top .el-form-item__label {
	padding: 0;
}

.themecolor .el-color-picker__trigger {
	width: 200px;
}

.el-form-item {
	margin-bottom: 0;
}

.el-card__body {
	padding: 10px;
}

// 文件上传
.image-uploader {
	height: 80px;
}
.image-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	width: 100px;
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.image-uploader .el-upload:hover {
	border-color: #409eff;
}
.image-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 80px;
	line-height: 80px;
	text-align: center;
}
.showimage {
	max-width: 70px;
	display: block;
}
.el-slider__button {
	width: 10px;
	height: 10px;
}
.el-slider__input {
	width: 92px;
}
.el-slider__runway {
	margin: 14px 0;
}
.el-slider__runway.show-input {
	margin-right: 110px;
	width: 100px;
}
.el-slider__input {
	float: none;
}
.phone {
	position: relative;
	width: 509px;
	height: 886px;
	display: flow-root;
	border-radius: 15px;
}
.phone .title {
	width: 489px;
	height: 50px;
	line-height: 50px;
	display: flex;
	background-color: #ebeef5;
	border-radius: 15px 15px 0 0;
	padding-left: 20px;
}
.images {
	animation: blink 1s linear infinite;
}
@keyframes blink {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
.themes {
	padding: 5px;
	border: 2px solid #ebeef5;
	cursor: pointer;
}
.athemes {
	padding: 5px;
	border: 2px solid #409eff;
	cursor: pointer;
}
.tipsDialog .el-dialog__body {
	height: auto;
	padding: 0 20px !important;
}
.hide_scroll::-webkit-scrollbar {
	display: none;
}
.flex-center {
	display: flex;
	align-items: center;
	justify-content: center;
}
.pr {
	position: relative;
}
.black_contain {
	width: 474px;
	margin: auto;
	height: 100%;
}
.red {
	font-size: 16px;
	display: inline-block;
}
.font_12_yahei {
	font-size: 12px;
	font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
		"Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	display: block;
}
</style>
